import styled from "styled-components";
import { Link } from "react-router-dom";

export const Button = styled.button`
  width: ${(props) => (props.width ? props.width : "")};
  height: ${(props) => (props.height ? props.height : "45px")};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "16px")};
  outline: none;
  border: none;
  cursor:pointer;
  margin-top:${(props) => (props.marginTop ? props.marginTop : "")};
  margin-left:${(props) => (props.marginL ? props.marginL : "")};
  margin:${(props) => (props.margin ? props.margin : "")};
  color: ${(props) => (props.color ? props.color : "white")};
  background-color:${(props) => (props.backgroundColor ? props.backgroundColor : " #437ced")};
  // background-image:  ${(props) => (props.backgroundImage ? props.backgroundImage : "#437ced")} ;
  border-radius: ${(props) => (props.borderRadius ? props.borderRadius : "5px")};
  padding:${(props) => (props.padding ? props.padding : "")};
  float:${(props) => (props.float ? props.float : "")};
  @media (max-width: 400px) {
    width:100% !important;
  }
  @media (min-width: 401px) and (max-width: 767px){
    width:100% !important;
  }
  &:hover{
    color:white !important;
    // background-image:linear-gradient(to right,#A45BE4 0%, #6B42F6 70%) !important;
    background-image:linear-gradient(315deg, rgb(68, 135, 209) 0%, rgb(0, 159, 253) 74%) !important;
    // box-shadow: 5px 5px 10px 1px grey;
  }

  // display: inline-block;
  // padding: .75rem 1.25rem;
  // border-radius: 10rem;
  // color: #fff;
  // text-transform: uppercase;
  // font-size: 1rem;
  // letter-spacing: .15rem;
  // transition: all .3s;
  // position: relative;
  // overflow: hidden;
  // z-index: 1;
  // &:after {
  //   content: '';
  //   position: absolute;
  //   bottom: 0;
  //   left: 0;
  //   width: 100%;
  //   height: 100%;
  //   background-color: $color;
  //   border-radius: 10rem;
  //   z-index: -2;
  // }
  // &:before {
  //   content: '';
  //   position: absolute;
  //   bottom: 0;
  //   left: 0;
  //   width: 0%;
  //   height: 100%;
  //   background-color:#437ced;
  //   transition: all .3s;
  //   border-radius: 10rem;
  //   z-index: -1;
  // }
  // &:hover {
  //   color: #fff !important;
  //   &:before {
  //     width: 100%;
  //   }
  // }

`;

export const ButtonGrey = styled.button`
  width: ${(props) => (props.width ? props.width : "")};
  height: ${(props) => (props.height ? props.height : "45px")};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "16px")};
  outline: none;
  border: none;
  cursor:pointer;
  margin-top:${(props) => (props.marginTop ? props.marginTop : "")};
  margin-left:${(props) => (props.marginL ? props.marginL : "")};
  margin:${(props) => (props.margin ? props.margin : "")};
  color: ${(props) => (props.color ? props.color : "white")};
  background-color:${(props) => (props.backgroundColor ? props.backgroundColor : " #437ced")};;
  border-radius: ${(props) => (props.borderRadius ? props.borderRadius : "5px")};
  padding:${(props) => (props.padding ? props.padding : "")};
  float:${(props) => (props.float ? props.float : "")};
  @media (max-width: 400px) {
    width:100% !important;
  }
`;

export const CustomLinkButLink = styled(Link)`
  margin-top: 10px !important;
  margin-left: 15px !important;
  width: 130px;
  text-align: center;
  padding: 9px 22px;
  border-radius: 16px;
  font-weight: 500;
  font-size: 13px;
  text-decoration: none;
  display: inline-block;
  background-color: ${(props) => (props.primary ? "rgb(21, 190, 238)" : "#fff")};
  color: ${(props) => (props.primary ? "#fff" : "rgb(21, 190, 238)")};
  border: ${(props) => (props.primary ? "none" : "1px solid rgb(21, 190, 238)")};
  font-family: work sans !important;
  cursor: pointer;
  transition: all 0.15s ease;
  &:hover {
    background-color: ${(props) => (props.primary ? "#3564d0" : "rgb(21, 190, 238)")} !important;
    color: #fff !important;
  }
  @media (max-width: 767px) {
    width: 100% !important;
    max-width: 100%;
    margin-left: 0 !important;
    margin-right: 0 !important;
    margin-bottom: 12px !important;
    display: block !important;
    box-sizing: border-box;
  }
`

